export enum UserRoles {
  CONNECTION_EDITOR = 'roles.userConnectionEditor',

  LEGACY_APP_USER = 'roles.legacyAppUser',
}
